import React from 'react'
import { Table } from 'react-bootstrap'

import {
  formatMoneyOrDash,
  valueOrDash
} from '../../../helpers/utils'
import FillRateProductDifferenceCell from './FillRateProductDifferenceCell'
import { getFillRateProductDifferenceMarkerStyle } from '../style/fillRateProductDifferencesStyles'

const FillRateProductDifferencesTable = ({ rows = [] }) => (
  <Table hover responsive>
    <thead className="table-header-gray">
      <tr>
        <th className="col-small">
          <span className="th-header-text">CÓDIGO</span>
        </th>
        <th className="col-small">
          <span className="th-header-text">CÓDIGO DE BARRA</span>
        </th>
        <th className="col-large">
          <span className="th-header-text">DESCRIPCIÓN</span>
        </th>
        <th className="col-small td-number-align-right">
          <span className="th-header-text">MONTO OC</span>
        </th>
        <th className="col-small td-number-align-right">
          <span className="th-header-text">MONTO PEDIDO</span>
        </th>
        <th className="col-small td-number-align-right">
          <span className="th-header-text">DIFERENCIA</span>
        </th>
      </tr>
    </thead>

    <tbody>
      {rows.length === 0 && (
        <tr>
          <td className="td-text-limited" colSpan="6">
            No hay resultados.
          </td>
        </tr>
      )}

      {rows.map((row, index) => (
        <tr key={`${row.product_code}-${row.product_barcode}-${index}`}>
          <td
            className="td-text-limited"
            style={getFillRateProductDifferenceMarkerStyle(row.difference)}
          >
            {valueOrDash(row.product_code)}
          </td>
          <td className="td-text-limited">
            {valueOrDash(row.product_barcode)}
          </td>
          <td className="td-text-limited">
            {valueOrDash(row.description)}
          </td>
          <td className="td-text-limited td-number-align-right">
            {formatMoneyOrDash(row.purchase_order_total)}
          </td>
          <td className="td-text-limited td-number-align-right">
            {formatMoneyOrDash(row.order_total)}
          </td>
          <td className="td-text-limited td-number-align-right">
            <FillRateProductDifferenceCell value={row.difference} />
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
)

export default FillRateProductDifferencesTable
